"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
exports.validationSchema = (0, yup_1.object)().shape({
    login: (0, yup_1.string)().required("form.validations.valueMissing"),
    password: (0, yup_1.string)().required("form.validations.valueMissing"),
});
//# sourceMappingURL=validation.js.map